import React from 'react';
import { useStyletron } from 'baseui';
import { Checkbox } from 'baseui/checkbox';
import { LabelSmall } from 'baseui/typography';
import { FRAME_FIELD, RELATIONSHIP_CREATOR_CONSTANTS } from '../../constants';
import type { FrameFieldT, TemporalScopeT } from '../../types/relationship';
import { FrameRangeInputs } from './frame-range-inputs';
type SameIntervalSectionProps = {
  sameInterval: boolean;
  temporalScope?: TemporalScopeT;
  sharedFrameRange: {
    startFrame?: number;
    endFrame?: number;
  };
  onSameIntervalToggle: (checked: boolean) => void;
  onSharedFrameChange: (field: FrameFieldT, value: number | undefined) => void;
};
export const SameIntervalSection = ({
  sameInterval,
  temporalScope,
  sharedFrameRange,
  onSameIntervalToggle,
  onSharedFrameChange
}: SameIntervalSectionProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.sizing.scale500
  })}>
      {sameInterval && temporalScope && <FrameRangeInputs temporalScope={temporalScope} startFrame={sharedFrameRange.startFrame} endFrame={sharedFrameRange.endFrame} onStartFrameChange={v => onSharedFrameChange(FRAME_FIELD.START, v)} onEndFrameChange={v => onSharedFrameChange(FRAME_FIELD.END, v)} />}

      <Checkbox checked={sameInterval} onChange={e => onSameIntervalToggle((e.target as HTMLInputElement).checked)} overrides={{
      Root: {
        style: {
          alignItems: 'center'
        }
      }
    }}>
        <LabelSmall margin={0}>{RELATIONSHIP_CREATOR_CONSTANTS.SAME_INTERVAL_LABEL}</LabelSmall>
      </Checkbox>
    </div>;
};